import { WarehouseCarrierServiceDTO } from '@invenco/warehousing-interface';

import { useGateways } from '@/gateways/GatewayProvider';
import { useEntityDetailsQuery, useGatewayMutation } from '@/shared/hooks/queries';

export function useWarehouseCarrierService(id?: string) {
  const { warehousingGateway } = useGateways();

  const {
    data: warehouseCarrierService,
    isLoading,
    refetch: refetchWarehouseCarrierService,
  } = useEntityDetailsQuery<WarehouseCarrierServiceDTO>({
    parentKey: 'warehouseCarrierServices',
    id,
    isNew: false,
    query: (fetchId, { signal }) =>
      warehousingGateway.getWarehouseCarrierService(fetchId, { signal }),
  });

  const { mutate: updateWarehouseCarrierService, isPending: isUpdatingWarehouseCarrierService } =
    useGatewayMutation<WarehouseCarrierServiceDTO, Partial<WarehouseCarrierServiceDTO>>({
      mutationFn: (warehouseCarrierService) =>
        warehousingGateway.updateWarehouseCarrierService(id!, warehouseCarrierService),
      linkedQuery: ['warehouseCarrierServices', id],
      linkResponseToQuery: false,
      successMessage: 'Warehouse carrier service updated',
    });

  return {
    warehouseCarrierService,
    isLoading,
    refetchWarehouseCarrierService,
    updateWarehouseCarrierService,
    isUpdatingWarehouseCarrierService,
  };
}
